const __WEBPACK_NAMESPACE_OBJECT__ = require("fast-safe-stringify");